import React from 'react';
import Image from 'next/image';
import Paragraph from 'structure/launchpad/components/Typography';
import Button from 'structure/launchpad/components/Button';
import { Input } from 'structure/staking/components/form/Input';
import { FormControl } from 'structure/staking/components/form/FormControl';
import { InputProps } from 'baseui/input';
import { getStaticAssetUrl } from 'utils/url';

type InputTokenAmountProps = Omit<InputProps, 'error' | 'min' | 'max'> & {
  label?: React.ReactNode;
  maxcontrol?: boolean;
  onMax?: () => void;
  tokenSymbol: string;
  error?: string | undefined;
  min?: string | number;
  max?: string | number;
};

export const InputTokenAmount = React.forwardRef(function (
  props: InputTokenAmountProps,
  ref: React.ForwardedRef<HTMLInputElement>
) {
  const {
    label,
    maxcontrol = true,
    tokenSymbol,
    min,
    max,
    onMax,
    error,
    ...rest
  } = props;

  const handleClickMax = () => {
    onMax?.();
  };

  return (
    <FormControl
      label={label}
      error={error}
      caption={
        maxcontrol ? (
          <div className='flex flex-row justify-end'>
            <Button
              type='button'
              onClick={handleClickMax}
              className='bg-transparent p-1 text-sm text-[#2E5BFF]'
            >
              MAX
            </Button>
          </div>
        ) : null
      }
    >
      <Input
        {...rest}
        min={Number(min) || undefined}
        max={Number(max) || undefined}
        type='number'
        step='any'
        inputRef={ref}
        startEnhancer={
          <div className='flex items-center gap-2'>
            <Image
              height={32}
              width={32}
              src={getStaticAssetUrl(
                `/sfi/static/image/token/${tokenSymbol}.svg`
              )}
              alt={tokenSymbol}
            />
            <Paragraph className='text-sm font-normal'>{tokenSymbol}</Paragraph>
          </div>
        }
      />
    </FormControl>
  );
});
